import { useEffect } from 'react'
import { getSectionPartysByBookId, getSectionPartyUsersBySectionId } from '../../../services/sBook/section-party.service'
                 
const useGetSectionPartysByBookId = (bookId, sectionPartyArray, setSectionPartyArray, setterBookSectionPartyList) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getSectionPartysByBookId(bookId);
                let response = serviceResponse.data

                if (response.succeeded) {
                    setSectionPartyArray(prevState => ({
                        ...prevState,
                        data: (response.data !== null ? response.data : [])
                    }));
    
                    setterBookSectionPartyList && setterBookSectionPartyList(response.data !== null ? response.data : []);
                }
                else {
                    setSectionPartyArray(prevState => ({
                        ...prevState,
                        data: []
                    }));
                    setterBookSectionPartyList && setterBookSectionPartyList([]);
                }
            }
            catch (error) {
                setSectionPartyArray(prevState => ({
                    ...prevState,
                    data: []
                }));
                setterBookSectionPartyList && setterBookSectionPartyList([]);
            }
        }
        
        if (bookId !== null && sectionPartyArray === null) {
            getData()
        }
    }, [bookId, sectionPartyArray, setSectionPartyArray, setterBookSectionPartyList]);
}

const useGetSectionPartyUsersBySectionId = (sectionId, partyId, sectionPartyUserList, setSectionPartyUserList, isPanelOpen) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getSectionPartyUsersBySectionId(sectionId, partyId);

                if (serviceResponse.data.succeeded) {
                    setSectionPartyUserList(prevState => ({
                        ...prevState,
                        data: serviceResponse.data.data
                    }));
                }
                else {
                    setSectionPartyUserList(prevState => ({
                        ...prevState,
                        data: []
                    }));
                }
            }
            catch (error) {
                setSectionPartyUserList(prevState => ({
                    ...prevState,
                    data: []
                }));
            }
        }
        
        if (sectionId !== null && partyId !== null && sectionPartyUserList === null && isPanelOpen === true) {
            getData()
        }
    }, [sectionId, partyId, sectionPartyUserList, setSectionPartyUserList, isPanelOpen]);
}

export {
    useGetSectionPartysByBookId,
    useGetSectionPartyUsersBySectionId,
}